import fetch from "auth/FetchInterceptor";

const productCategoryEndpointPrefix = "/productCategory";
const productCategoryService = {};

productCategoryService.getAllForAdminSchool = async () =>
	await fetch(`${productCategoryEndpointPrefix}/getAllForAdminSchool`, {
		method: "GET",
	});

productCategoryService.createProductCategory = async ({ category }) =>
	await fetch(`${productCategoryEndpointPrefix}/create`, {
		method: "POST",
		data: category,
	});

export default productCategoryService;
